import * as React from 'react';

import { ITableColumn } from './index';

interface ITableHeaderProps {
    isLoading?: boolean;
    columns: ITableColumn[];
}

const TableHeader: React.StatelessComponent<ITableHeaderProps> = (props) => {
    return (
        <thead>
            <tr>
                {props.columns.map((column: ITableColumn, index: number) => (
                    <th key={`th-${index}`}>{column.name}</th>
                ))}
            </tr>
        </thead>
    );
};

export default TableHeader;



// WEBPACK FOOTER //
// ./src/components/common/table/TableHeader.tsx